module.exports = __webpack_public_path__ + "img/top_icon03.c8c1375.png";